import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Visit } from 'app/core/model/entity-model';
import { ArkUnitOfWork, AppInformationService, SessionInformationService } from 'app/core/core.module';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { Subject } from 'rxjs';
import _ from 'lodash';
import { DevExtremeModule } from 'devextreme-angular';

@Component({
    selector: 'app-visit-detail',
    templateUrl: './visit-detail.component.html',
    styleUrls: ['./visit-detail.component.scss'],
    imports: [DevExtremeModule]
})
export class VisitDetailComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    visit: Visit;
    visitId: any;
    types: any[];
    people: any;
    showAsDialog = false;
    previousVisits: any;
    familyId: any;

    constructor(
        private uow: ArkUnitOfWork,
        public appInfo: AppInformationService,
        private sessionInfo: SessionInformationService,
        private route: ActivatedRoute,
        private router: Router,
        protected location: Location
    ) {}

    async ngOnInit() {
        this.appInfo.pleaseWaitShow();

        this.types = await this.uow.getVisitTypes();
        this.people = await this.uow.getPeople();
        this.people.forEach((person) => {
            person.name = person.firstName + ' ' + person.lastName;
        });

        if (!!this.showAsDialog) {
            this.visit = !!this.visitId ? await this.uow.visits.byId(this.visitId) : this.uow.visits.createEntity();
            this.visit.date = moment(new Date()).startOf('day').toDate();
            if (this.familyId) {
                const members = ((await this.uow.families.byId(this.familyId, 'members')) as any).members;
                const personId = _.find(members, { relationshipId: 1 }).id;
                this.previousVisits = await this.uow.getPreviousVisits(personId);
                this.previousVisits.forEach((visit) => {
                    if (visit.visitedBy) visit.by = visit.visitedBy.firstName + ' ' + visit.visitedBy.lastName;
                });
                this.visit.personId = personId;
            }
        } else {
            this.visitId = this.route.snapshot.params['id'];
            if (this.visitId !== 'new') {
                this.visit = await this.uow.visits.byId(this.visitId);
            } else {
                this.visit = this.uow.visits.createEntity();
                const date = this.sessionInfo.getItem('visits:lastVisitDate') || moment().toDate();
                this.visit.date = moment(date).startOf('day').toDate();
            }
        }

        this.appInfo.pleaseWaitHide();
    }

    get hasChanges() {
        return this.uow.hasChanges();
    }

    close() {
        try {
            this.location.back();
        } catch {
            this.router.navigate(['/people/list/']);
        }
    }

    closeDialog() {
        if (this.showAsDialog) this.result.next({ success: false });
    }

    async save() {
        this.appInfo.pleaseWaitShow();
        await this.uow.commit();
        this.appInfo.pleaseWaitHide();
        if (this.showAsDialog) this.result.next({ success: true });
        else this.sessionInfo.setItem('visits:lastVisitDate', this.visit.date);
    }

    cancel() {
        this.uow.rollback();
        if (this.visitId === 'new') this.close();
        if (this.showAsDialog) this.closeDialog();
    }
}
